import { hirerExpAxiosInstance } from './apiInstance';
import { DefaultDelay, retrier } from './apiRetry';
import type { TealiumExperiments } from './models';

export async function getExperiments(): Promise<TealiumExperiments> {
  const experimentsResponse = await retrier(
    () => hirerExpAxiosInstance().get<TealiumExperiments>(`/experiments`),
    {
      strategy: 'fixed',
      delayMs: DefaultDelay,
    },
  );
  return experimentsResponse.data;
}
